import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Profile from './views/Profile.vue'
import Activation from "./views/Activation";
import BuyCredit from "./views/BuyCredit";
import Wallets from "./views/Wallets";
import Vehicle from './views/Vehicle.vue'
import Regularize from "./views/Regularize";
import History from './views/History';
import ActivateOCRHistory from "./views/ActivateOCRHistory";
import Faq from "@/views/Faq.vue";

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/estacionar',
            name: 'activation',
            component: Activation,
        },
        {
            path: '/comprar/creditos',
            name: 'buyCredit',
            component: BuyCredit,
        },
        {
            path: '/carteiras',
            name: 'wallets',
            component: Wallets,
        },
        {
            path: '/vehicles',
            name: 'vehicles',
            component: Vehicle,
        },
        {
            path: '/irregularidades',
            name: 'regularize',
            component: Regularize,
        },
        {
            path: '/historico',
            name: 'history',
            component: History,
        },
        {
            path: '/historico/ativacoes',
            name: 'activateHistoryOCR',
            component: ActivateOCRHistory,
        },
        {
            path: '/perfil',
            name: 'profile',
            component: Profile,
        },
        {
            path: '/motorista',
            name: 'motorista',
        },
        {
            path: '/faq',
            name: 'faq',
            component: Faq,
        },
        {
            path: "*",
            component: Home
        },
    ]
})